var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4541 0C14.6577 0.075481 14.8614 0.201283 14.9378 0.402565C15.0651 0.704489 14.9887 0.956092 14.785 1.2077C14.3013 1.7109 13.8431 2.21411 13.3594 2.74247C12.0356 4.17661 10.7117 5.58559 9.36247 7.01973C9.15881 7.24617 9.03152 7.49777 9.05698 7.82486C9.05698 9.13319 9.05698 10.4415 9.05698 11.7499C9.05698 12.077 8.95515 12.3286 8.75148 12.5802C8.08957 13.335 7.42767 14.0646 6.76576 14.8194C6.61301 14.9704 6.46026 15.0459 6.23114 14.9704C6.02748 14.8949 5.92565 14.7439 5.92565 14.5427C5.92565 14.4923 5.92565 14.442 5.92565 14.3917C5.92565 12.2028 5.92565 10.0138 5.92565 7.82486C5.92565 7.52293 5.82381 7.24617 5.62015 7.01973C3.83809 5.10754 2.05604 3.19536 0.273977 1.30834C-0.158809 0.83029 -0.0824346 0.201283 0.528557 0C5.16191 0 9.82072 0 14.4541 0Z",
    fill: "#3CC0A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.da76bbdac91bae236ea30f26cde1fb85.svg";
export { ForwardRef as ReactComponent };